import React from 'react';
import LanguagePreferences from './language-preferences';
import TimezonePreferences from './timezone-preferences';


const LanguageAndTimezone = () => (
  <React.Fragment>
    <LanguagePreferences />
    <hr />
    <TimezonePreferences />
  </React.Fragment>
);

export default LanguageAndTimezone;


